import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Text, Flex } from '@components';

export const AccountDisabled = (): JSX.Element => {
  const theme = useTheme();

  return (
    <Flex alignItems='flex-start' flexDirection='column' pt={16} gap={17}>
      <Flex alignItems='center' flexDirection='column' gap={15}>
        <Text variant='h4' fontWeight='fontWeightBold'>
          <FormattedMessage id='login.accountDisabled' />
        </Text>
        <Text
          variant='h5'
          textAlign='center'
          fontWeight='fontWeightRegular'
          style={{
            color: theme.palette.grey.A100,
            marginTop: theme.spacing(3),
          }}
        >
          <FormattedMessage id='login.accountDisabledDescription' />
        </Text>
        <Text
          variant='h5'
          textAlign='center'
          fontWeight='fontWeightRegular'
          style={{
            color: theme.palette.grey.A100,
            marginTop: theme.spacing(3),
          }}
        >
          <FormattedMessage id='login.followInstructions' />
        </Text>
      </Flex>
    </Flex>
  );
};
